import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./CreateOrganisation.module.css";
import { toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import {
  getAllOrganisation,
  getIndustryMaster,
  getTypeMaster,
} from "../../reduxSlices/organisationSlice";
import { CustomTextField, generateFinancialYearMonths } from "../../helpers/helper";
import { getPackageMaster } from "../../reduxSlices/packageSlice";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import { validateName, validateId } from "../../helpers/helper";

const service = new Service();

const CreateOrganisation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { organizationId } = useParams();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [packageValue, setPackageValue] = useState([]);
  const [organization, setOrganization] = useState({
    organizationId: "",
    organizationName: "",
    organizationType: "",
    industry: "",
    packages: [],
    users: [],
    financialYearStartMonth: "",
    isValidName: false,
    isValidId: false,
  });
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const packageMaster = useSelector((state) => state?.package?.packageMaster);
  const allOrganisation = useSelector(
    (state) => state.organization.allOrganisation
  );
  const typeOptions = useSelector((state) => state?.organization?.typeMaster);
  const industryOptions = useSelector(
    (state) => state?.organization?.industryMaster
  );

  const currentYear = new Date().getFullYear();
  const financialYearMonths = generateFinancialYearMonths();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const areInputsFilled = () => {
    return (
      organization?.organizationName?.trim() !== "" &&
      organization?.organizationType?.hasOwnProperty("name") &&
      organization?.industry?.hasOwnProperty("name") &&
      organization?.financialYearStartMonth?.hasOwnProperty("name") &&
      // organization?.email?.trim() !== "" &&
      organization?.packages?.length > 0 &&
      organization?.organizationId?.trim() !== ""
    );
  };
  const inputFilled = areInputsFilled();

  const handleInputFocus = (e) => {
    setIsClicked(true);
  };

  const getOrganisationData = async () => {
    const obj = {
      searchText: "",
      organizationType: [],
      industry: [],
      package: [],
    };
    await dispatch(getAllOrganisation(obj));
  };

  useEffect(() => {
    if (!organizationId) return;
    getOrganisationData();
  }, [organizationId]);

  useEffect(() => {
    if (!allOrganisation && !organizationId) return;
    if (allOrganisation && organizationId) {
      const filterOrganisation = allOrganisation?.filter(
        (item) => item.organizationId === organizationId
      );
      filterOrganisation?.map((item) =>
        setOrganization({
          organizationId: item?.organizationId,
          organizationName: item?.organizationName,
          organizationType: {
            id: item?.organizationType,
            name: item?.organizationType,
          },
          industry: {
            id: item?.industry,
            name: item?.industry,
          },
          financialYearStartMonth: financialYearMonths?.find(
            (el) => el?.value === item?.financialYearStartMonth
          ),
          packages: item?.packages,
          users: item?.users,
        })
      );
    }
  }, [organizationId, allOrganisation]);

  useEffect(() => {
    console.log("organization>>>>", organization);
  }, [organization]);

  useEffect(() => {
    if (!isClicked) return;
    if (!organizationId) {
      dispatch(setAddButtonDisabled(inputFilled));
    } else {
      dispatch(setUpdateButtonDisabled(inputFilled));
    }
  }, [inputFilled, isClicked]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: !organizationId ? "add-organisation" : "edit-organisation",
        title: !organizationId
          ? "Add & Configure New Organisation"
          : "Edit & Re-Configure Organisation",
        subTitle: !organizationId
          ? "Please add organisation details and configure with users, packages and data translation settings"
          : "Please update organisation details and re-configure other settings if there are any discrepancies",
      })
    );
    dispatch(getTypeMaster());
    dispatch(getIndustryMaster());
    dispatch(getPackageMaster());
    dispatch(setAddButtonDisabled(false));
    dispatch(setUpdateButtonDisabled(false));
  }, []);

  useEffect(() => {
    if (
      (buttonAction.page === "add-organisation" &&
        buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-organisation") &&
        buttonAction.action === "update")
    ) {
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-organisation" &&
        buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-organisation") &&
        buttonAction.action === "cancel")
    ) {
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    setPackageValue(organization?.packages);
  }, [organizationId, organization?.packages]);

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setOrganization({
      ...organization,
      [name]: value,
    });
  };

  const handleAutoCompleteChange = (name, value) => {
    setOrganization((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = (e) => {
    if (!organizationId) {
      createOrganisation();
    } else {
      updateOrganisation();
    }
  };

  const createOrganisation = async () => {
    if (organization.isValidName &&
      organization.isValidId) {
      setIsButtonClicked(false);
      setLoader(true);
      let url = `/api/Organization/AddOrganization`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPostApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          setLoader(false);
          toast.success("Orgnaisation has been created", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/organisations");
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    }
    else {
      setIsButtonClicked(true);
    }
  };

  const updateOrganisation = async () => {
    if (organizationId && organization.isValidName && organization.isValidId) {
      setLoader(true);
      let url = `/api/Organization/UpdateOrganization?id=${organizationId}`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          toast.success("Orgnaisation details have been updated", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/organisations");
          setLoader(false);
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    }
    else {
      setIsButtonClicked(true);
    }
  };

  const prepareOrganisationData = () => {
    return {
      organizationId: organization?.organizationId,
      organizationName: organization?.organizationName,
      organizationType: organization?.organizationType?.name,
      industry: organization?.industry?.name,
      financialYearStartMonth: organization?.financialYearStartMonth?.value,
      packages: organization?.packages ? organization?.packages : [],
      users: [],
    };
  };

  const prepData = prepareOrganisationData();
  console.log("prepData>>>", prepData);

  const getOptionLabel = (option) => option?.name;

  const findIntersection = (item) => {
    return packageValue?.map((el) => el?.packageId)?.includes(item?.packageId);
  };
  const getSelectedValue = (e) => {
    console.log("eeeeee", findIntersection(e), e);
    if (packageValue && packageValue.length > 0 && findIntersection(e)) {
      let filterNetworks = packageValue.filter(
        (data) => data?.packageId != e?.packageId
      );
      setPackageValue(filterNetworks);
      setOrganization({ ...organization, packages: [...filterNetworks] });
    } else {
      let arr = [...packageValue, e];
      setPackageValue(arr);
      setOrganization({ ...organization, packages: [...arr] });
    }
    dispatch(setUpdateButtonDisabled(inputFilled));
    setIsClicked(true);
  };

  useEffect(() => {
    const isNameValid = validateName(organization.organizationName);
    const isIdValid = validateId(organization.organizationId);
    if (organization.organizationName && organization.organizationId) {
      setOrganization({ ...organization, isValidName: isNameValid, isValidId: isIdValid });
    }
  }, [organization.organizationName, organization.organizationId]);

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "0 32px 10px 0",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px", width: "550px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation Name<sup style={requiredAr}>*</sup>
            </label>
            <CustomTextField
              placeholder="Enter the organisation name..."
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="organizationName"
              value={organization?.organizationName}
              onChange={handleOrganizationChange}
              onFocus={handleInputFocus}
            />
            {organization?.organizationName && !organization?.isValidName && isButtonClicked && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                Text is not valid.
              </Typography>
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={{ ...labelStyle, marginBottom: "20px" }}>
              Packages<sup style={requiredAr}>*</sup>
            </label>
            <div className={styles.container}>
              {packageMaster &&
                packageMaster?.map((item, i) => (
                  <div
                    key={i}
                    className={styles.child}
                    style={{
                      backgroundColor: findIntersection(item) ? "#56a5a1" : "",
                      border: findIntersection(item) ? "#56a5a1" : "",
                      color: findIntersection(item) ? "#fff" : "",
                    }}
                    onClick={() => getSelectedValue(item)}
                  >
                    {item?.packageName}
                  </div>
                ))}
            </div>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation Type<sup style={requiredAr}>*</sup>
            </label>
            <CustomAutocomplete
              options={typeOptions}
              value={organization?.organizationType}
              onChange={(e, value) =>
                handleAutoCompleteChange("organizationType", value)
              }
              getOptionLabel={getOptionLabel}
              onFocus={handleInputFocus}
              placeholder="Select organisation type..."
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Organisation Industry<sup style={requiredAr}>*</sup>
            </label>
            <CustomAutocomplete
              options={industryOptions}
              value={organization?.industry}
              onChange={(e, value) =>
                handleAutoCompleteChange("industry", value)
              }
              getOptionLabel={getOptionLabel}
              onFocus={handleInputFocus}
              placeholder="Select industry type..."
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Blackbaud Organisation Id<sup style={requiredAr}>*</sup>
            </label>
            <CustomTextField
              placeholder="Enter blackbaud id..."
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="organizationId"
              value={organization?.organizationId}
              onChange={handleOrganizationChange}
              onFocus={handleInputFocus}
            />
               {organization?.organizationId && !organization?.isValidId && isButtonClicked && (
              <Typography
                sx={{
                  color: "red",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                Text is not valid.
              </Typography>
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Financial Year Start Month<sup style={requiredAr}>*</sup>
            </label>
            <CustomAutocomplete
              options={financialYearMonths}
              value={organization?.financialYearStartMonth}
              onChange={(e, value) =>
                handleAutoCompleteChange("financialYearStartMonth", value)
              }
              getOptionLabel={getOptionLabel}
              onFocus={handleInputFocus}
              placeholder="Select financial year start month..."
            />
          </Box>
        </Box>
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreateOrganisation;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};
